import { render, staticRenderFns } from "./StatPanel.vue?vue&type=template&id=1e8b1dd1&"
import script from "./StatPanel.vue?vue&type=script&lang=js&"
export * from "./StatPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports